// componente per la visualizzazione del footer; non contiene metodi particolari, ma permette di esportare la classe "FooterComponent"
// con la sua pagina HTML ed il suo scss

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    constructor(
    ) {
    }

    ngOnInit() {
    }
}
